import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable/components";
import { useMedia } from "@/hooks/useMedia";
import { useActiveVersionNumber } from "@/lib/hooks/useActiveVersionNumber";
import { useMessageStore } from "@/state/stores";
import { FileList } from "./FileList";
import { FileOutput } from "./FileOutput";

export function FileAttachmentView() {
  const versionNumber = useActiveVersionNumber();

  const hasFiles = useMessageStore((state) => {
    const versionInfo = Object.values(state.versionInformation).find(
      (info) => info.version === versionNumber,
    );
    return !!versionInfo && versionInfo.files.length > 0;
  });

  const isNarrow = useMedia("(max-width: 1728px)");

  return (
    <ResizablePanelGroup direction={isNarrow ? "vertical" : "horizontal"}>
      {hasFiles && (
        <>
          <ResizablePanel defaultSize={20} minSize={6}>
            <FileList />
          </ResizablePanel>

          <ResizableHandle />
        </>
      )}

      <ResizablePanel className="[&>pre]:h-[calc(100%-2.5rem)]">
        {hasFiles === false ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center text-muted-foreground">
              No code yet—once the agent cooks something, it'll show up here.
            </div>
          </div>
        ) : (
          <FileOutput />
        )}
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
